import 'babel-polyfill'
import objectFitImages from 'object-fit-images'
import '@fancyapps/fancybox'
import {without, throttle, debounce} from 'lodash'
import 'reframe.js/dist/jquery.reframe.min'
import whatInput from 'what-input'
import 'jquery-match-height/jquery.matchHeight'

import './ad-tracking'
import './content'
import './selects'
import './front-page'
import './header'
import './load-more'
import './news'
import './partners'
//import './player-search'
//import './score/score'

objectFitImages()

jQuery.fancybox.defaults.animationEffect = 'fade'
jQuery.fancybox.defaults.gash = false
jQuery.fancybox.defaults.buttons = [
    'close'
]
jQuery.fancybox.defaults.clickContent = false

jQuery( '[data-fancybox="popup"]' ).fancybox({
    arrows : false,
});

jQuery('.content iframe:not(.content .no-resize iframe)').reframe()

// if (jQuery('.intro').hasClass('intro--with-image')) {
//     jQuery('.header__main-nav').addClass('header__main-nav-trn')
// } else {
//     if (jQuery('body').hasClass('home') || jQuery('body').hasClass('page-template-tournament')) {
//
//     } else {
//         jQuery('.header').addClass('header--white-bg')
//     }
// }

jQuery(document).ready(function () {
    let newsSidebar = jQuery('.news__sidebar')

    if (window.matchMedia("(min-width: 1024px)").matches) {
        newsSidebar.appendTo('.news__wrapper')
    } else {
        newsSidebar.prependTo('.news__aside')
    }

    //console.log('READY');

    if ( jQuery('#wpadminbar').length > 0 ) {
        let height = jQuery('.header').outerHeight() - jQuery('#wpadminbar').outerHeight()

        jQuery('body').css( 'padding-top', height )
    } else
        jQuery('body').css( 'padding-top', jQuery('.header').outerHeight() )

    jQuery('.block').matchHeight( { byRow: true } );

    if (window.matchMedia("(min-width: 1024px)").matches && window.matchMedia("(max-width: 1279px)").matches) {
        //424 = sidebar__width + margins
        let news_width = jQuery(window).width() - 424
        jQuery( '.featured__news' ).css( 'width', news_width )
    }

})

jQuery(window).resize(function(){
    if ( jQuery('#wpadminbar').length > 0 ) {
        let height = jQuery('.header').outerHeight() - jQuery('#wpadminbar').outerHeight()

        jQuery('body').css( 'padding-top', height )
    } else
        jQuery('body').css( 'padding-top', jQuery('.header').outerHeight() )

    if (window.matchMedia("(min-width: 1024px)").matches && window.matchMedia("(max-width: 1279px)").matches) {
        //424 = sidebar__width + margins
        let news_width = jQuery(window).width() - 424
        jQuery( '.featured__news' ).css( 'width', news_width )
    } else
        jQuery( '.featured__news' ).css( 'width', '100%' )
})
